$('.Package__icon-img').on({
    "mouseover" : function() {
        this.src = 'assets/static-img/question-mark.png';
    },
    "mouseout" : function() {
        this.src='assets/static-img/q_mark_white_bg.png';
    }
});
